// Mobile navigation fix script
document.addEventListener('DOMContentLoaded', function() {
  // Force navbar to be transparent immediately
  const navbar = document.querySelector('.navbar-logo-center');
  if (navbar) {
    navbar.style.backgroundColor = 'rgba(255, 255, 255, 0)';
    navbar.style.borderBottom = '1px solid rgba(179, 211, 54, 0)';
    
    // Add transition to navbar for smooth effect
    navbar.style.transition = 'background-color 0.3s ease, border-bottom 0.3s ease';
  }
  
  // Small delay to override Webflow's JS
  setTimeout(function() {
    // Select elements
    const menuButton = document.querySelector('.menu-button');
    const navMenu = document.querySelector('.nav-menu-wrapper-three');
    let menuOpen = false;
    
    // Mobile detection
    const isMobile = () => window.innerWidth <= 991;
    
    // Add CSS for mobile menu behavior
    const style = document.createElement('style');
    style.textContent = `
      @media screen and (max-width: 991px) {
        .nav-menu-wrapper-three {
          transform: translateX(100%);
          opacity: 0;
          position: fixed !important;
          top: 0 !important;
          right: 0 !important;
          left: 0 !important;
          bottom: 0 !important;
          width: 100% !important;
          height: 100vh !important;
          z-index: 999 !important;
          transition: transform 0.3s ease, opacity 0.3s ease !important;
          display: none;
          padding-top: 80px;
        }
        
        .nav-menu-wrapper-three.mobile-open {
          transform: translateX(0) !important;
          opacity: 1 !important;
          display: block !important;
        }
        
        .nav-menu-three {
          position: relative !important;
          top: 0 !important;
          right: 0 !important;
          max-width: 95% !important;
          margin: 0 auto !important;
          box-shadow: 0 5px 15px rgba(0,0,0,0.1) !important;
        }
        
        .menu-button {
          z-index: 9999 !important;
          position: relative !important;
        }
        
        /* Always green button on mobile */
        .button-primary {
          background-color: #b3d336 !important;
          color: #231f20 !important;
        }
        
        /* Always black menu text on mobile/tablet */
        .nav-link {
          color: #231f20 !important;
        }
        
        /* Always dark hamburger button */
        .menu-button {
          color: #231f20 !important;
        }
      }
      
      /* Add transitions to elements for smooth color changes */
      .nav-link, .navbar-brand-three, .image-6, .button-primary, .menu-button {
        transition: color 0.3s ease, background-color 0.3s ease, filter 0.3s ease;
      }
    `;
    document.head.appendChild(style);
    
    // Replace the menu button
    if (menuButton) {
      // Clone the button to remove event listeners
      const newBtn = menuButton.cloneNode(true);
      menuButton.parentNode.replaceChild(newBtn, menuButton);
      
      // Add our custom handler
      newBtn.addEventListener('click', toggleMenu);
      newBtn.addEventListener('touchstart', function(e) {
        e.preventDefault(); // Prevent double-tap issues
        toggleMenu(e);
      }, {passive: false});
      
      function toggleMenu(e) {
        e.preventDefault();
        e.stopPropagation();
        
        menuOpen = !menuOpen;
        
        if (menuOpen) {
          // Open menu
          newBtn.classList.add('w--open');
          navMenu.style.display = 'block';
          
          // Force a reflow
          void navMenu.offsetWidth;
          
          // Add class for transition
          navMenu.classList.add('mobile-open');
        } else {
          // Close menu
          newBtn.classList.remove('w--open');
          navMenu.classList.remove('mobile-open');
          
          // Hide after transition
          setTimeout(function() {
            if (!menuOpen) {
              navMenu.style.display = 'none';
            }
          }, 300);
        }
        
        return false;
      }
      
      // Close menu when clicking menu items
      const menuItems = navMenu.querySelectorAll('a');
      menuItems.forEach(function(item) {
        item.addEventListener('click', function() {
          if (isMobile()) {
            menuOpen = false;
            newBtn.classList.remove('w--open');
            navMenu.classList.remove('mobile-open');
            
            setTimeout(function() {
              navMenu.style.display = 'none';
            }, 300);
          }
        });
      });
    }
    
    // Get current path once
    const currentPath = window.location.pathname;
    const isSpecialPage = 
      currentPath.includes('/pages/our-story') ||
      currentPath.includes('/cart') ||
      currentPath.includes('/privacy') ||
      currentPath.includes('/terms') ||
      currentPath.includes('/shipping') ||
      currentPath.includes('/login') ||
      currentPath.includes('/account') ||
      currentPath.includes('/products/') ||
      currentPath.includes('/account/');
    
    // IMPROVED SCROLL TRANSITION FUNCTION
    function handleScroll() {
      const navLinks = document.querySelectorAll('.nav-link');
      const navBrand = document.querySelector('.navbar-brand-three');
      const logoImage = document.querySelector('.image-6');
      const button = document.querySelector('.button-primary');
      const menuBtn = document.querySelector('.menu-button');
      
      // Check current scroll position
      const scrollPosition = window.scrollY;
      const scrollThreshold = 20;
      const scrollRange = 40;
      
      // *** INITIALIZATION - Set initial styles based on page type ***
      // We need to handle this only once, outside the scroll handler
      
      // For mobile/tablet, always set specific styles
      if (isMobile()) {
        // Never invert cart icon on mobile/tablet
        if (logoImage) {
          logoImage.style.filter = 'contrast(100%) brightness(100%)';
        }
        
        // Mobile links always black
        navLinks.forEach(function(link) {
          link.style.color = '#231f20';
        });
        
        if (menuBtn) {
          menuBtn.style.color = '#231f20';
        }
        
        // On mobile, button always green with black text
        if (button) {
          button.style.backgroundColor = '#b3d336';
          button.style.color = '#231f20';
        }
      }
      
      // Calculate opacity based on scroll position - more gradual transition
      let bgOpacity = 0;
      let borderOpacity = 0;
      
      if (scrollPosition > scrollThreshold) {
        // Calculate opacity based on scroll position
        bgOpacity = Math.min((scrollPosition - scrollThreshold) / scrollRange, 1);
        borderOpacity = bgOpacity;
        
        // Apply calculated opacity to background
        if (navbar) {
          navbar.style.backgroundColor = `rgba(255, 254, 227, ${bgOpacity})`;
          navbar.style.borderBottom = `1px solid rgba(179, 211, 54, ${borderOpacity})`;
        }
        
        if (!isMobile()) {
          // Begin transitioning text color based on the same opacity value
          navLinks.forEach(function(link) {
            // Interpolate between white and dark text
            const r = Math.round(255 - (255 - 35) * bgOpacity);
            const g = Math.round(255 - (255 - 31) * bgOpacity);
            const b = Math.round(255 - (255 - 31) * bgOpacity);
            
            // Check if we're on a special page, which uses different colors
            if (isSpecialPage) {
              link.style.color = '#231f20';
            } else {
              link.style.color = `rgb(${r}, ${g}, ${b})`;
            }
          });
          
          if (navBrand && !isSpecialPage) {
            // Interpolate the filter
            const invertValue = 100 - (100 * bgOpacity);
            const brightnessValue = 200 - (100 * bgOpacity);
            navBrand.style.filter = `invert(${invertValue}%) brightness(${brightnessValue}%)`;
          }
          
          if (logoImage && !isMobile() && !isSpecialPage) {
            const invertValue = 100 - (100 * bgOpacity);
            const brightnessValue = 200 - (100 * bgOpacity);
            logoImage.style.filter = `invert(${invertValue}%) brightness(${brightnessValue}%)`;
          }
          
          if (menuBtn && !isSpecialPage) {
            // Interpolate between white and dark
            const r = Math.round(255 - (255 - 35) * bgOpacity);
            const g = Math.round(255 - (255 - 31) * bgOpacity);
            const b = Math.round(255 - (255 - 31) * bgOpacity);
            menuBtn.style.color = `rgb(${r}, ${g}, ${b})`;
          }
        }
        
        // Full opacity - completed scroll transition
        if (bgOpacity >= 1) {
          if (navbar) {
            navbar.style.backgroundColor = 'rgba(255, 254, 227, 1)';
            navbar.style.borderBottom = '1px solid rgba(179, 211, 54, 1)';
          }
          
          if (!isMobile()) {
            navLinks.forEach(function(link) {
              link.style.color = 'rgb(35, 31, 31)';
            });
            
            if (navBrand) {
              navBrand.style.filter = 'invert(0%) brightness(100%)';
            }
            
            if (logoImage) {
              logoImage.style.filter = 'contrast(100%) brightness(100%)';
            }
            
            if (menuBtn) {
              menuBtn.style.color = '#231f20';
            }
          }
        }
      } else {
        // Top state - TRANSPARENT background
        if (navbar) {
          navbar.style.backgroundColor = 'rgba(255, 255, 255, 0)';
          navbar.style.borderBottom = '1px solid rgba(179, 211, 54, 0)';
        }
        
        if (!isMobile()) {
          if (isSpecialPage) {
            // Special pages styling
            navLinks.forEach(function(link) {
              link.style.color = '#231f20';
            });
            
            if (navBrand) {
              navBrand.style.filter = 'invert(0%) brightness(100%)';
            }
            
            if (logoImage) {
              logoImage.style.filter = 'contrast(100%) brightness(100%)';
            }
            
            if (menuBtn) {
              menuBtn.style.color = '#231f20';
            }
          } else {
            // Regular pages styling
            navLinks.forEach(function(link) {
              link.style.color = 'rgb(255, 255, 255)';
            });
            
            if (navBrand) {
              navBrand.style.filter = 'invert(100%) brightness(200%)';
            }
            
            if (logoImage) {
              logoImage.style.filter = 'invert(100%) brightness(200%)';
            }
            
            if (menuBtn) {
              menuBtn.style.color = '#ffffff';
            }
          }
        }
      }
      
      // Button always remains green with black text regardless of scroll position
      if (button) {
        button.style.backgroundColor = '#b3d336';
        button.style.color = '#231f20';
      }
    }
    
    // Run handleScroll immediately and on every scroll
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    
    // IMPORTANT: Use a small timeout to let the DOM fully initialize
    // This prevents the flash/inversion issue
    setTimeout(handleScroll, 10);
    
    // Close menu on window resize if moving to desktop
    let lastWidth = window.innerWidth;
    window.addEventListener('resize', function() {
      if (lastWidth <= 991 && window.innerWidth > 991 && menuOpen) {
        // We've switched from mobile to desktop with open menu
        menuOpen = false;
        document.querySelector('.menu-button').classList.remove('w--open');
        navMenu.classList.remove('mobile-open');
        navMenu.style.display = '';
      }
      lastWidth = window.innerWidth;
    });
    
  }, 300);
});